module.exports = __webpack_public_path__ + "static/img/facial-recognition.631edcc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/recent-works/facial-recognition.png
// module id = sl3P
// module chunks = 1